"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleAuthEndpoint = exports.storageKeyLegacy = exports.storageKey = exports.authApi = exports.setConfig = exports.getConfig = void 0;
const production = {
  authApi: 'https://api.creditas.io/auth',
  authSessionKey: 'authSession',
  authSessionLegacyKey: 'ember_simple_auth-session',
  singleAuthEndpoint: 'https://www.creditas.com/auth/single-auth'
};
const staging = {
  authApi: 'https://stg-api.creditas.io/auth',
  authSessionKey: 'authSession',
  authSessionLegacyKey: 'ember_simple_auth-session',
  singleAuthEndpoint: 'https://staging.creditas.com/auth/single-auth'
};
const development = {
  authApi: 'https://dev-api.creditas.io/auth',
  authSessionKey: 'authSession',
  authSessionLegacyKey: 'ember_simple_auth-session',
  singleAuthEndpoint: 'https://staging.creditas.com/auth/single-auth'
};
const local = {
  authApi: '/auth',
  authSessionKey: 'authSession',
  authSessionLegacyKey: 'ember_simple_auth-session',
  singleAuthEndpoint: 'https://www.creditas.com/auth/single-auth'
};
const localApi = {
  authApi: '/api/auth',
  authSessionKey: 'authSession',
  authSessionLegacyKey: 'ember_simple_auth-session',
  singleAuthEndpoint: 'https://www.creditas.com/auth/single-auth'
};
const config = {
  environment: 'production',
  production,
  staging,
  development,
  local,
  localApi
};

const getConfig = () => config[config.environment];

exports.getConfig = getConfig;

const getConfigParam = key => getConfig()[key];

const setConfig = environment => {
  config.environment = environment;
};

exports.setConfig = setConfig;

const authApi = () => getConfigParam('authApi');

exports.authApi = authApi;

const storageKey = () => getConfigParam('authSessionKey');

exports.storageKey = storageKey;

const storageKeyLegacy = () => getConfigParam('authSessionLegacyKey');

exports.storageKeyLegacy = storageKeyLegacy;

const singleAuthEndpoint = () => getConfigParam('singleAuthEndpoint');

exports.singleAuthEndpoint = singleAuthEndpoint;